export const baseUrl = "https://admin.ekohomez.in/";
export const baseMediaUrl = "https://admin.ekohomez.in/";

export const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
};
